/**
 * Колір годинника, статуса мережі та стану аккумялятора на iPhone
 */

export function iosShowDarkStatusBar(){
    //Пофарбувати годинники на ios в чорний
    try{
        window.webkit.messageHandlers.showDarkStatusBar.postMessage('');
    }catch(err){
// expected to fail on non-iOS devices
    }
}

export function iosShowLightStatusBar(){
    //Пофарбувати годинники на ios в білий
    try{
        window.webkit.messageHandlers.showLightStatusBar.postMessage('');
    }catch(err){
// expected to fail on non-iOS devices
    }
}